import { render, staticRenderFns } from "./TourOverlay.vue?vue&type=template&id=fe6a1c38&scoped=true"
import script from "./TourOverlay.vue?vue&type=script&lang=js"
export * from "./TourOverlay.vue?vue&type=script&lang=js"
import style0 from "./TourOverlay.vue?vue&type=style&index=0&id=fe6a1c38&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe6a1c38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe6a1c38')) {
      api.createRecord('fe6a1c38', component.options)
    } else {
      api.reload('fe6a1c38', component.options)
    }
    module.hot.accept("./TourOverlay.vue?vue&type=template&id=fe6a1c38&scoped=true", function () {
      api.rerender('fe6a1c38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tours/TourOverlay.vue"
export default component.exports